export const ENV_REQUIRED_ERROR = 'Select at least one environment.';
